'use strict';

var _classCallCheck = require("/var/www/repository/Production-Zocial-AdminPanel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/var/www/repository/Production-Zocial-AdminPanel/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var constants = require('./constants');
var MT = constants.MT;
var SIMPLE = constants.SIMPLE;
var SYMS = constants.SYMS;

/**
 * A CBOR Simple Value that does not map onto a known constant.
 */
var Simple = /*#__PURE__*/function () {
  /**
   * Creates an instance of Simple.
   *
   * @param {integer} value - the simple value's integer value
   */
  function Simple(value) {
    _classCallCheck(this, Simple);
    if (typeof value !== 'number') {
      throw new Error('Invalid Simple type: ' + typeof value);
    }
    if (value < 0 || value > 255 || (value | 0) !== value) {
      throw new Error('value must be a small positive integer: ' + value);
    }
    this.value = value;
  }

  /**
   * Debug string for simple value
   *
   * @returns {string} simple(value)
   */
  _createClass(Simple, [{
    key: "toString",
    value: function toString() {
      return 'simple(' + this.value + ')';
    }
    /**
     * Debug string for simple value
     *
     * @returns {string} simple(value)
     */
  }, {
    key: "inspect",
    value: function inspect() {
      return 'simple(' + this.value + ')';
    }
    /**
     * Push the simple value onto the CBOR stream
     *
     * @param {cbor.Encoder} gen - The generator to push onto
     * @returns {number}
     */
  }, {
    key: "encodeCBOR",
    value: function encodeCBOR(gen) {
      return gen._pushInt(this.value, MT.SIMPLE_FLOAT);
    }
    /**
     * Is the given object a Simple?
     *
     * @param {any} obj - object to test
     * @returns {bool} - is it Simple?
     */
  }], [{
    key: "isSimple",
    value: function isSimple(obj) {
      return obj instanceof Simple;
    }
    /**
     * Decode from the CBOR additional information into a JavaScript value.
     * If the CBOR item has no parent, return a "safe" symbol instead of
     * `null` or `undefined`, so that the value can be passed through a
     * stream in object mode.
     *
     * @param {number} val - the CBOR additional info to convert
     * @param {bool} hasParent - Does the CBOR item have a parent?
     * @returns {(null | undefined | boolean | symbol)} - the decoded value
     */
  }, {
    key: "decode",
    value: function decode(val, hasParent) {
      if (hasParent == null) {
        hasParent = true;
      }
      switch (val) {
        case SIMPLE.FALSE:
          return false;
        case SIMPLE.TRUE:
          return true;
        case SIMPLE.NULL:
          if (hasParent) {
            return null;
          } else {
            return SYMS.NULL;
          }
        case SIMPLE.UNDEFINED:
          if (hasParent) {
            return undefined;
          } else {
            return SYMS.UNDEFINED;
          }
        case -1:
          if (!hasParent) {
            throw new Error('Invalid BREAK');
          }
          return SYMS.BREAK;
        default:
          return new Simple(val);
      }
    }
  }]);
  return Simple;
}();
module.exports = Simple;